import { createGlobalStyle } from "styled-components"
import { REGULAR_FONT, BOLD_FONT, SEMI_BOLD_FONT } from "../const"
import RegularWoff from "../assets/fonts/MessinaSansWeb-Regular.woff"
import RegularWoff2 from "../assets/fonts/MessinaSansWeb-Regular.woff2"
import BoldWoff from "../assets/fonts/MessinaSansCondensedWeb-Bold.woff"
import BoldWoff2 from "../assets/fonts/MessinaSansCondensedWeb-Bold.woff2"
import SemiBoldWoff from "../assets/fonts/MessinaSansMonoWeb-SemiBold.woff"
import SemiBoldWoff2 from "../assets/fonts/MessinaSansMonoWeb-SemiBold.woff2"

const GlobalFont = createGlobalStyle`
  @font-face {
      font-family: "${REGULAR_FONT.NAME}";
      src: url("${RegularWoff}") format("woff"),
            url("${RegularWoff2}") format("woff2");
      font-weight: ${REGULAR_FONT.WEIGHT};
      font-style: normal;
      font-display: block;
    }
    @font-face {
      font-family: "${BOLD_FONT.NAME}";
      src: url("${BoldWoff}") format("woff"),
            url("${BoldWoff2}") format("woff2");
      font-weight: ${BOLD_FONT.WEIGHT};
      font-style: normal;
      font-display: block;
    }
    @font-face {
      font-family: "${SEMI_BOLD_FONT.NAME}";
      src: url("${SemiBoldWoff}") format("woff"),
              url("${SemiBoldWoff2}") format("woff2");
      font-weight: ${SEMI_BOLD_FONT.WEIGHT};
      font-style: normal;
      font-display: block;
    }
`
export default GlobalFont
